import { AuthBootstrap } from "@nexus/shared-core";
import { RouterProvider, createBrowserRouter } from "react-router";
import EnvironmentConfigs from "./configs";
import ErrorPage from "./pages/Error";
import Layout from "./pages/Layout";
import MeetPage from "./pages/MeetPage";
import RecapPage from "./pages/RecapPage";

import "@nexus/shared-ui/style.scss";
import "./assets/scss/index.scss";

const MainLayout = () => {
  const environments = EnvironmentConfigs();

  // let params = new URL(document.location.toString()).searchParams;
  // let token = params.get("token");

  return (
    <AuthBootstrap
      clientId={environments.clientId}
      scope={environments.scope}
      authority={environments.appAuthorityBaseUrl}
      autoSignIn={false}
    >
      <Layout />
    </AuthBootstrap>
  );
};

const App = ({ basename }: any) => {
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <MainLayout />,
        children: [
          {
            path: ":meetingId",
            element: <MeetPage />,
          },
          {
            path: "recap/:meetingId",
            element: <RecapPage />,
          },
          {
            path: "error",
            element: <ErrorPage />,
          },
          {
            path: "*",
            element: <ErrorPage />,
          },
        ],
      },
    ],
    {
      basename: basename || "/",
    }
  );
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default App;
